import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class PhoneVerificationCodeIncorrectError extends CodedError {
  static get errorName() {
    return errorCodes.phoneVerificationCodeIncorrectError.code;
  }

  constructor(
    message: string = errorCodes.phoneVerificationCodeIncorrectError.message
  ) {
    super(message);
    this.code = errorCodes.phoneVerificationCodeIncorrectError.code;
    this.message = `${message} ${errorCodes.phoneVerificationCodeIncorrectError.code}`;
    this.name = errorCodes.phoneVerificationCodeIncorrectError.name;
  }
}
